import { ConstraintDrillFracInterferenceBase } from './base/constraint-drill-frac-interference-base';

export class ConstraintDrillFracInterference extends ConstraintDrillFracInterferenceBase { }